

























































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'

import ModalDialogHelper from '@/mixins/ModalDialogHelper'
import ProjectLimitsMixin from '@/mixins/ProjectLimitsMixin'

import store from '@/store'

const InvitesInfoPanel = () => import('@/components/invites/InvitesInfoPanel.vue')

interface LimitInfo
{
	name: string
	singular: string
	icon: string
	max: number
}

@Component
export default class FeatureLimitsDisplay extends Mixins(ModalDialogHelper, ProjectLimitsMixin)
{
	@Prop({ default: () => [] }) items!: string[]
	@Prop({ default: true }) clickable!: boolean
	@Prop({ default: 'is-primary' }) tooltipType!: string

	private activeByItems: {[key: string]: boolean} = {}

	private get tagsClasses()
	{
		return {
			tags: true,
			'has-addons': true,
			clickable: this.clickable
		}
	}

	get maxProjects()
	{
		return store.getters['userMetaData/maxProjects']
	}

	get maxImages()
	{
		return store.getters['userMetaData/maxImages']
	}

	get maxAudio()
	{
		return store.getters['userMetaData/maxAudio']
	}

	get maxLevels()
	{
		return store.getters['userMetaData/maxLevels']
	}

	get maxScreens()
	{
		return store.getters['userMetaData/maxScreens']
	}

	get maxElements()
	{
		return store.getters['userMetaData/maxElements']
	}

	get assetLimits()
	{
		return [
			{ name: 'images', singular: 'image', icon: 'image', max: this.maxImages },
			{ name: 'levels', singular: 'level', icon: 'gamepad', max: this.maxLevels },
			{ name: 'screens', singular: 'screen', icon: 'application', max: this.maxScreens },
			{ name: 'elements', singular: 'custom element', icon: 'star', max: this.maxElements },
			{ name: 'audio', singular: 'sound', icon: 'music-note', max: this.maxAudio }
		]
	}

	@Watch('items')
	private onItemsChanged(newVal: string[])
	{
		this.updateActiveByItems()
	}

	created()
	{
		this.updateActiveByItems()
	}

	private handleShowInfo()
	{
		if (!this.clickable)
		{
			return
		}

		// @ts-ignore
		const modal = this.$buefy.modal.open({
			// parent: this,
			component: InvitesInfoPanel,
			hasModalCard: true
		})

		this.bringToFront(modal)
	}

	private updateActiveByItems()
	{
		this.activeByItems = {}
		this.items.forEach(key => {
			this.activeByItems[key] = true
		})
	}

	private getTooltip(limit: LimitInfo)
	{
		const baseInfo = `${limit.max} ${this.pluralize(limit.singular, limit.max)}`

		switch (limit.name)
		{
			case 'levels':
			case 'screens':
			case 'elements':
			case 'projects':
			{
				return `Create up to ${baseInfo}`
			}

			case 'images':
			case 'audio':
			{
				return `Upload up to ${baseInfo}`
			}
		}

		return baseInfo
	}

	private pluralize(singular: string, count: number)
	{
		// NOTE: there is a more sophisticated library on npm
		// called pluralize
		if (count === 1)
		{
			return singular
		}

		return `${singular}s`
	}
}

